import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'together',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/together',
			name: 'together-funnel',
		},
	},
	funnel: {
		id: 'ob-subscription-share-invitee-signup',
		route: {
			path: '/together/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'together-onboarding',
		},
		slug: 'together',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-main',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
